import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import 'process/browser';
import reportWebVitals from "./reportWebVitals"; // Ensure this file exists or remove the line if unnecessary

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
      <App />
  </React.StrictMode>
);

// Report web vitals
reportWebVitals();
